import axios from 'axios';
const axiosServices = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3010/' });

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('errrrr...', error);
    if (error.response.status === 401 && !window.location.href.includes('/login')) {
      console.log('hello');
      window.location.pathname = '/login';
    }
    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

export default axiosServices;
